﻿import { MessageTypeEnum } from '../enums';
export class CustomAlertModel {
    message: string;
    timeOut: number;
    customButton?: boolean;
    customButtonText?: string;
    messageType: MessageTypeEnum;
    data?: any;
    constructor() {
        this.message = '';
        this.customButton = false;
        this.timeOut = 4000;
    }
}